module.exports = __webpack_public_path__ + "img/bigImg1.fdf674dc.png";